import { RouteConfig } from 'vue-router'

const route: RouteConfig[] = [
  {
    path: '/awards',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/Recognition/Index.vue')
      }
    ],
    meta: { requiresAuth: true }
  }
]

export default route
